import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useAuth } from '../../context/AuthContext';

function Footer() {
  const { loggedIn } = useAuth();

  if (!loggedIn) return null;

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 'auto',
        backgroundColor: '#fff',
        borderTop: '1px solid #e0e0e0',
      }}
    >
      <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
        Rentabilidades pasadas no garantizan rentabilidades futuras.
      </Typography>
      <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
        Ondara Capital, S.L. (B67229757) y Vern Properties, S.L. (B02980639) son empresas del Grupo Ondara.
        Ondara Capital, S.L. es una sociedad, regulada, supervisada y registrada en el Banco de España con el código de Entidad D552.
      </Typography>
      <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
        We Make Sure. © {new Date().getFullYear()} Ondara.
      </Typography>
    </Box>
  );
};

export default Footer;